import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * A component that shows the data for payment by link. It shows a QR code that the user can scan to go to the payment link, as well as a button when it gets clicked, it opens a new tab with the payment link.
 *
 * @param {Object} props
 * @param {string} props.qrCode - Base64 of the QR code image which contains the payment link
 * @param {string} props.payByLinkPaymentLink - The url of the payment link
 * @param {string} props.email - The email of the user whom the email was sent to
 * @returns {JSX.Element}
 */

export default function PayByLinkQr({ qrCode, payByLinkPaymentLink, email }) {
  const { t } = useTranslation("global");
  const base64Data = qrCode.replace("PNG,", "");

  const handleRedirect = () => {
    window.open(payByLinkPaymentLink, "_blank"); // Open the link in a new tab
  };

  return (
    <div>
      <div className="flex justify-center">
        <Button
          className="mt-3 bg-background_steel_blue text-text_white hover:bg-gray-100 font-medium text-lg px-10 py-2.5 me-2 mb-2"
          onClick={() => handleRedirect()}
          type="button"
        >
          {t("hero.pay_link_text")}
        </Button>
      </div>

      <div className="flex justify-center">
        <img src={`data:image/png;base64,${base64Data}`} alt="QR Code" />
      </div>

      <div>
        <p className="text-text-black text-center mt-2">
          {t("payment_link_long_text")}{" "}
          <span className="text-text_steel_blue">{email}</span>{" "}
          {t("payment_scan")}
        </p>
      </div>
    </div>
  );
}
